import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import noFind from "@/views/noFind.vue";

import { getSource } from "@/http/sys";

const Home = () => import("../views/home/index.vue");

const routes = [
    {
        path: "/",
        name: Home,
        component: Home,
        meta: {
            title: "首页",
        }
    },
    {
        path: '/:catchAll(.*)',
        name: '/404',
        component: noFind
    },
]

const router = createRouter({
    history: process.env.NODE_ENV === 'production' ? createWebHistory() : createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    next()
    // getSourceFn(to);
})


const getSourceFn = async (to) => {
    console.log(to);
    // 生成一个随机数 类似于uuid
    let userId = "";
    if (localStorage.getItem('userId')) {
        userId = localStorage.getItem('userId')
    } else {
        userId = Math.random().toString(36).substr(2, 10)
    }
    // 存储到localStorage
    localStorage.setItem('userId', userId);


    try {
        const { code, data } = await getSource({
            path: to.path,
            utmSource: to.query?.utmSource || JSON.stringify(to.query),
            userId: userId,
        });

    } catch (e) {
        console.log("getSource err::", e)
    }
}


export default router
